module.exports = {"511923001":"同州街道","511923002":"金宝街道","511923003":"江口街道","511923101":"响滩镇","511923102":"西兴镇","511923103":"佛楼镇","511923104":"白衣镇","511923105":"涵水镇","511923106":"岳家镇","511923107":"兰草镇","511923108":"驷马镇","511923110":"元山镇","511923111":"云台镇","511923112":"邱家镇","511923113":"笔山镇","511923114":"镇龙镇","511923115":"得胜镇","511923118":"灵山镇","511923119":"土兴镇","511923120":"望京镇","511923121":"龙岗镇","511923122":"板庙镇","511923123":"泥龙镇","511923125":"青云镇","511923126":"大寨镇","511923127":"土垭镇","511923128":"澌岸镇","511923130":"粉壁镇","511923133":"三十二梁镇","511923134":"江家口镇","511923135":"岩口镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511923.json
// module id = 2523
// module chunks = 0